import { render } from "./ReviewsView.vue?vue&type=template&id=2587008e"
import script from "./ReviewsView.vue?vue&type=script&lang=js"
export * from "./ReviewsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__